
// src/Components/conferencePages/ImportantDates.js
import React from "react";
import { GiVideoConference } from "react-icons/gi";
import { BsEnvelopePaper } from "react-icons/bs";
import { IoIosNotifications } from "react-icons/io";
import { GoChecklist } from "react-icons/go";
import styles from "./ImportantDates.module.css"
import { FaHourglassStart } from "react-icons/fa";

export default function ImportantDates() {
  return (
    <div>
      {/* Important Dates */}
      <section className={styles.datesSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Important Dates</h2>
          <div className={styles.datesGrid}>

            <div className={styles.dateCard}>
              <GoChecklist size={32} className={styles.dateIcon} />
              <h3 className={styles.dateTitle}>Submission Begins</h3>
              <p className={styles.dateValue}>25 July</p>
              <p className={styles.dateYear}>2026</p>
            </div>

            <div className={styles.dateCard}>
              <BsEnvelopePaper size={32} className={styles.dateIcon} />
              <h3 className={styles.dateTitle}>Submission Deadline</h3>
              <p className={styles.dateValue}>20 November</p>
              <p className={styles.dateYear}>2026</p>
            </div>

            <div className={styles.dateCard}>
              <IoIosNotifications size={32} className={styles.dateIcon} />
              <h3 className={styles.dateTitle} style={{whiteSpace:'nowrap',marginLeft:'-7px'}}>Notification of Acceptance</h3>
              <p className={styles.dateValue}>25 November</p>
              <p className={styles.dateYear}>2026</p>
            </div>

            <div className={styles.dateCard}>
              <FaHourglassStart size={32} className={styles.dateIcon} />
              <h3 className={styles.dateTitle}>Registration Deadline</h3>
              <p className={styles.dateValue}>10 December</p>
              <p className={styles.dateYear}>2026</p>
            </div>

            <div className={styles.dateCard}>
              <GiVideoConference  size={32} className={styles.dateIcon} />
              <h3 className={styles.dateTitle}>Conference Dates</h3>
              <p className={styles.dateValue}>29 - 30 December</p>
              <p className={styles.dateYear}>2026</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}